export default __webpack_public_path__ + "static/gatsby_deploy_success-07fac9c7b5e4bccbc3f94e524e3b4caa.png";